<template>
  <div class="A06_gsfc aboutchild">
    <div class="aboutchildbox">
      <div class="title">
        <img src="@/common/images/about/A10_xgsm/titleL.png" alt="" />
        <span>支付公示</span>
        <img src="@/common/images/about/A10_xgsm/titleR.png" alt="" />
      </div>
      <div class="imgs">
        <div class="item zg">
          <p>单位名称：财富在线（深圳）科技有限公司</p>
          <p>开户行：中国银行深圳证券交易所支行</p>
          <p>单位账号：7614 7357 9024</p>
        </div>
        <div class="item zs">
          <p>单位名称：财富在线（深圳）科技有限公司</p>
          <p>开户行：招商银行深圳分行营业部</p>
          <p>单位账号：1209 0435 4110 802</p>
        </div>
      </div>
      <!-- <div class="imgs">
        <div class="item js">
          <p style="margin-left: 71px;">单位名称：深圳德讯证券顾问有限公司</p>
          <p style="margin-left: 71px;">开户行：中国农业银行股份有限公司深圳珠宝中心支行</p>
          <p>单位账号：4102 6200 0400 34056</p>
        </div> -->
        <!-- <div class="item hx">
          <p>单位名称：深圳德讯证券顾问有限公司</p>
          <p>开户行：华夏银行深圳东门支行</p>
          <p>单位账号：1085 9000 0005 1222 0</p>
        </div> -->
      <!-- </div> -->
      <div class="warning">
        <img src="@/common/images/about/A07_zfgs/warning.png" alt="" />
        <p>
          本公司仅通过支付公示的账号接受用户汇款，如有任何人员提供非支付公示的账户要求汇款的，均属于违法犯罪行为。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "A07_zfgs",
  data() {
    return {
      pages: {
        current: 1,
        total: 100,
        size: 10,
      },
      
    };
  },
  mounted() {
    this.getlist();
  },
  methods: {
    getlist: function () {
      // console.log("lawColumn");
    },
    pagefun: function (p) {
      console.log(p);
    },
    toDetail: function () {
      this.$router.push({ path: "/B10_xgsm" });
    },
  },
};
</script>
<style scoped>
.aboutchild {
  width: 1198px;
  overflow: hidden;
  opacity: 1;
  background: #fff;
  margin-left: 220px;
  min-height: 940px;

}
.aboutchildbox {
  opacity: 1;
  /* margin: 0 44px; */
  overflow: hidden;
}
.title {
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 36px;
}
.title span {
  display: block;
  height: 56px;
  font-size: 40px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  opacity: 1;
  margin: 0 50px;
}
.imgs {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  float: left;
}
.imgs .item {
  width: 578px;
  height: 344px;
  margin: 0 10px;
}
.imgs .zg {
  background: url("../../common/images/about/A07_zfgs/img1.png") no-repeat;
}
.imgs .zs {
  background: url("../../common/images/about/A07_zfgs/img2.png") no-repeat;
}
.imgs .js {
  background: url("../../common/images/about/A07_zfgs/2256.png") no-repeat;
}
.imgs .hx {
  background: url("../../common/images/about/A07_zfgs/img4.png") no-repeat;
}
.item p {
  text-align: left;
}
/* .js p{
  height: 28px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 28px;
  color: #514444;
  margin-top: 178px;
  margin-left: 110px;
} */
.zg p:nth-child(1),
.zs p:nth-child(1),
.js p:nth-child(1),
.hx p:nth-child(1) {
  height: 28px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 28px;
  color: #514444;
  margin-top: 178px;
  margin-left: 119px;
}
.zg p:nth-child(2),
.zs p:nth-child(2),
.js p:nth-child(2),
.hx p:nth-child(2) {
  height: 28px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 28px;
  color: #514444;
  margin-top: 18px;
  margin-left: 119px;
}
.zg p:nth-child(3),
.zs p:nth-child(3),
.js p:nth-child(3),
.hx p:nth-child(3) {
  height: 40px;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 40px;
  color: #ffffff;
  margin-top: 34px;
  margin-left: 38px;
}
.warning {
  width: 1201px;
  height: 56px;
  background: #f2f2f2;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  display: flex;
  justify-content: left;
  align-items: center;
  margin-left: 12px;
}
.warning img {
  width: 24px;
  height: 24px;
  margin: 0 12px;
}
.warning p {
  width: 1144px;
  height: 30px;
  font-size: 22px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #d83731;
  line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/aboutS/A07_zfgs.vue